
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SelectAnnouncementsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"types"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"releaseStartDatePeriodStart"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AWSDateTime"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"releaseStartDatePeriodEnd"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AWSDateTime"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"releaseEndDatePeriodStart"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AWSDateTime"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"releaseEndDatePeriodEnd"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AWSDateTime"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"importantFlg"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"keywords"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"announcements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"announcementInput"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"types"},"value":{"kind":"Variable","name":{"kind":"Name","value":"types"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"releaseStartDatePeriodStart"},"value":{"kind":"Variable","name":{"kind":"Name","value":"releaseStartDatePeriodStart"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"releaseStartDatePeriodEnd"},"value":{"kind":"Variable","name":{"kind":"Name","value":"releaseStartDatePeriodEnd"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"releaseEndDatePeriodStart"},"value":{"kind":"Variable","name":{"kind":"Name","value":"releaseEndDatePeriodStart"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"releaseEndDatePeriodEnd"},"value":{"kind":"Variable","name":{"kind":"Name","value":"releaseEndDatePeriodEnd"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"importantFlg"},"value":{"kind":"Variable","name":{"kind":"Name","value":"importantFlg"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"keywords"},"value":{"kind":"Variable","name":{"kind":"Name","value":"keywords"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"pageSize"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"announcements"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"announcement"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"release_type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"release_start_date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"release_end_date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"important_flg"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"created_at"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"pagination"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pageSize"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rowCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pageCount"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":919}};
    doc.loc.source = {"body":"query SelectAnnouncementsQuery(\n  $types: [String], $releaseStartDatePeriodStart: AWSDateTime, $releaseStartDatePeriodEnd: AWSDateTime, $releaseEndDatePeriodStart: AWSDateTime, $releaseEndDatePeriodEnd: AWSDateTime, $importantFlg: Boolean, $keywords: [String], $page: Int, $pageSize: Int,\n) {\n  announcements(\n    announcementInput: {\n      types: $types, releaseStartDatePeriodStart: $releaseStartDatePeriodStart, releaseStartDatePeriodEnd: $releaseStartDatePeriodEnd, releaseEndDatePeriodStart: $releaseEndDatePeriodStart, releaseEndDatePeriodEnd: $releaseEndDatePeriodEnd, importantFlg: $importantFlg, keywords: $keywords, page: $page, pageSize: $pageSize,\n    }\n  ) {\n    announcements {\n      announcement\n      title\n      release_type\n      release_start_date\n      release_end_date\n      important_flg\n      created_at\n    }\n    pagination {\n      page\n      pageSize\n      rowCount\n      pageCount\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["SelectAnnouncementsQuery"] = oneQuery(doc, "SelectAnnouncementsQuery");
        
